'use client';

import { c as _c } from "react/compiler-runtime";
import { safeParseNumber } from '@morpho-org/blue-sdk-viem';
import { type InterfaceToken, toBigInt, ZERO } from '@morpho-org/dapp-core';
import { isDefined } from '@morpho-org/morpho-ts';
import { InfoTooltip } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Separator } from '@repo/ui';
import { InfoHoverCardTrigger } from '@/components/common/InfoHoverCardTrigger';
import { getParsedValue } from '@/helpers/formatters';
import { splitValueAndUnit } from '@/helpers/number';
import { trackMetricTooltipOpenChange } from '@/lib/analytics/client/trackers/metric-tooltip';
import type { VaultV2HeroData } from './VaultV2Hero.mapper';
interface VaultV2LiquidityHoverCardProps {
  vaultV2: VaultV2HeroData;
  asset: InterfaceToken | null | undefined;
}
export const VaultV2LiquidityHoverCard = t0 => {
  const $ = _c(72);
  const {
    vaultV2,
    asset
  } = t0;
  let t1;
  if ($[0] !== asset?.symbol || $[1] !== vaultV2.assetDecimals) {
    t1 = value => formatters.short.digits(2).trailingZero(false).default("-").unit(asset?.symbol).of(value, vaultV2.assetDecimals);
    $[0] = asset?.symbol;
    $[1] = vaultV2.assetDecimals;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const formatAssetAmount = t1;
  let formattedAdapterLiquidity;
  let formattedIdleLiquidity;
  let formattedLiquidity;
  let formattedLiquidityUsd;
  let formattedTotalUnderlyingLiquidity;
  let t2;
  if ($[3] !== formatAssetAmount || $[4] !== vaultV2.forceDeallocatableLiquidity || $[5] !== vaultV2.forceDeallocatableLiquidityUsd || $[6] !== vaultV2.idleAssets || $[7] !== vaultV2.liquidity || $[8] !== vaultV2.liquidityAdapterAssets || $[9] !== vaultV2.liquidityUsd || $[10] !== vaultV2.totalUnderlyingLiquidity) {
    const forceDeallocatableLiquidity = toBigInt(vaultV2.forceDeallocatableLiquidity) ?? ZERO;
    const withdrawableLiquidity = toBigInt(vaultV2.liquidity);
    const liquidity = withdrawableLiquidity == null ? null : withdrawableLiquidity + forceDeallocatableLiquidity;
    let t3;
    if ($[17] !== formatAssetAmount || $[18] !== liquidity) {
      t3 = formatAssetAmount(liquidity);
      $[17] = formatAssetAmount;
      $[18] = liquidity;
      $[19] = t3;
    } else {
      t3 = $[19];
    }
    formattedLiquidity = t3;
    let t4;
    if ($[20] !== vaultV2.forceDeallocatableLiquidityUsd) {
      t4 = getParsedValue(vaultV2.forceDeallocatableLiquidityUsd, safeParseNumber);
      $[20] = vaultV2.forceDeallocatableLiquidityUsd;
      $[21] = t4;
    } else {
      t4 = $[21];
    }
    const forceDeallocatableLiquidityUsd = t4;
    let t5;
    if ($[22] !== forceDeallocatableLiquidityUsd || $[23] !== vaultV2.liquidityUsd) {
      const liquidityUsd = getParsedValue(vaultV2.liquidityUsd, safeParseNumber);
      t5 = splitValueAndUnit(formatters.short.digits(2).trailingZero(false).default("-").of(isDefined(liquidityUsd) ? liquidityUsd + (forceDeallocatableLiquidityUsd ?? ZERO) : undefined, 18));
      $[22] = forceDeallocatableLiquidityUsd;
      $[23] = vaultV2.liquidityUsd;
      $[24] = t5;
    } else {
      t5 = $[24];
    }
    formattedLiquidityUsd = t5;
    let t6;
    if ($[25] !== formatAssetAmount || $[26] !== vaultV2.totalUnderlyingLiquidity) {
      t6 = formatAssetAmount(toBigInt(vaultV2.totalUnderlyingLiquidity));
      $[25] = formatAssetAmount;
      $[26] = vaultV2.totalUnderlyingLiquidity;
      $[27] = t6;
    } else {
      t6 = $[27];
    }
    formattedTotalUnderlyingLiquidity = t6;
    let t7;
    if ($[28] !== formatAssetAmount || $[29] !== vaultV2.idleAssets || $[30] !== vaultV2.liquidityAdapterAssets) {
      const idleAssets = toBigInt(vaultV2.idleAssets);
      const adapterLiquidity = toBigInt(vaultV2.liquidityAdapterAssets);
      formattedIdleLiquidity = formatAssetAmount(idleAssets);
      t7 = formatAssetAmount(adapterLiquidity);
      $[28] = formatAssetAmount;
      $[29] = vaultV2.idleAssets;
      $[30] = vaultV2.liquidityAdapterAssets;
      $[31] = formattedIdleLiquidity;
      $[32] = t7;
    } else {
      formattedIdleLiquidity = $[31];
      t7 = $[32];
    }
    formattedAdapterLiquidity = t7;
    t2 = formatAssetAmount(forceDeallocatableLiquidity);
    $[3] = formatAssetAmount;
    $[4] = vaultV2.forceDeallocatableLiquidity;
    $[5] = vaultV2.forceDeallocatableLiquidityUsd;
    $[6] = vaultV2.idleAssets;
    $[7] = vaultV2.liquidity;
    $[8] = vaultV2.liquidityAdapterAssets;
    $[9] = vaultV2.liquidityUsd;
    $[10] = vaultV2.totalUnderlyingLiquidity;
    $[11] = formattedAdapterLiquidity;
    $[12] = formattedIdleLiquidity;
    $[13] = formattedLiquidity;
    $[14] = formattedLiquidityUsd;
    $[15] = formattedTotalUnderlyingLiquidity;
    $[16] = t2;
  } else {
    formattedAdapterLiquidity = $[11];
    formattedIdleLiquidity = $[12];
    formattedLiquidity = $[13];
    formattedLiquidityUsd = $[14];
    formattedTotalUnderlyingLiquidity = $[15];
    t2 = $[16];
  }
  const formattedDeallocatableLiquidity = t2;
  let t3;
  if ($[33] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <span className="text-foreground text-sm leading-none">Liquidity</span>;
    $[33] = t3;
  } else {
    t3 = $[33];
  }
  let t4;
  if ($[34] !== formattedLiquidity) {
    t4 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t3}<span className="text-foreground text-sm leading-none">{formattedLiquidity}</span></div>;
    $[34] = formattedLiquidity;
    $[35] = t4;
  } else {
    t4 = $[35];
  }
  let t5;
  if ($[36] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = <div className="px-sm my-1.5"><Separator /></div>;
    $[36] = t5;
  } else {
    t5 = $[36];
  }
  let t6;
  if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <span className="text-2xs text-secondary-foreground leading-none">Liquidity Adapter</span>;
    $[37] = t6;
  } else {
    t6 = $[37];
  }
  let t7;
  if ($[38] !== formattedAdapterLiquidity) {
    t7 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t6}<span className="text-2xs text-secondary-foreground leading-none">{formattedAdapterLiquidity}</span></div>;
    $[38] = formattedAdapterLiquidity;
    $[39] = t7;
  } else {
    t7 = $[39];
  }
  let t8;
  if ($[40] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <span className="text-2xs text-secondary-foreground leading-none">Idle Liquidity</span>;
    $[40] = t8;
  } else {
    t8 = $[40];
  }
  let t9;
  if ($[41] !== formattedIdleLiquidity) {
    t9 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t8}<span className="text-2xs text-secondary-foreground leading-none">{formattedIdleLiquidity}</span></div>;
    $[41] = formattedIdleLiquidity;
    $[42] = t9;
  } else {
    t9 = $[42];
  }
  let t10;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="gap-2xs flex items-center"><span className="text-2xs text-secondary-foreground leading-none">Deallocatable Liquidity</span><InfoTooltip tooltipContent="Liquidity that can be permissionlessly moved from markets back to the vault's idle assets via forced deallocation." /></div>;
    $[43] = t10;
  } else {
    t10 = $[43];
  }
  let t11;
  if ($[44] !== formattedDeallocatableLiquidity) {
    t11 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t10}<span className="text-2xs text-secondary-foreground leading-none">{formattedDeallocatableLiquidity}</span></div>;
    $[44] = formattedDeallocatableLiquidity;
    $[45] = t11;
  } else {
    t11 = $[45];
  }
  let t12;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <div className="px-sm my-1.5"><Separator /></div>;
    $[46] = t12;
  } else {
    t12 = $[46];
  }
  let t13;
  if ($[47] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="gap-2xs flex items-center"><span className="text-2xs text-secondary-foreground leading-none">Total Underlying Liquidity</span><InfoTooltip tooltipContent="The sum of the underlying liquidity across all markets this vault is exposed to." /></div>;
    $[47] = t13;
  } else {
    t13 = $[47];
  }
  let t14;
  if ($[48] !== formattedTotalUnderlyingLiquidity) {
    t14 = <div className="px-sm gap-y-2xs flex min-h-8 flex-wrap items-center justify-between gap-x-4 py-[1px]">{t13}<span className="text-2xs text-secondary-foreground leading-none" data-testid="vault-v2-total-underlying-liquidity">{formattedTotalUnderlyingLiquidity}</span></div>;
    $[48] = formattedTotalUnderlyingLiquidity;
    $[49] = t14;
  } else {
    t14 = $[49];
  }
  let t15;
  if ($[50] !== t11 || $[51] !== t14 || $[52] !== t4 || $[53] !== t7 || $[54] !== t9) {
    t15 = <div className="py-sm min-w-0">{t4}{t5}{t7}{t9}{t11}{t12}{t14}</div>;
    $[50] = t11;
    $[51] = t14;
    $[52] = t4;
    $[53] = t7;
    $[54] = t9;
    $[55] = t15;
  } else {
    t15 = $[55];
  }
  const hoverCardContent = t15;
  let t16;
  if ($[56] === Symbol.for("react.memo_cache_sentinel")) {
    t16 = <span className="text-secondary-foreground text-xs" style={{
      whiteSpace: "nowrap"
    }}>Liquidity</span>;
    $[56] = t16;
  } else {
    t16 = $[56];
  }
  let t17;
  if ($[57] !== hoverCardContent) {
    t17 = <div className="gap-2xs flex items-center">{t16}<InfoHoverCardTrigger maxWidth="400px" onOpenChange={_temp}>{hoverCardContent}</InfoHoverCardTrigger></div>;
    $[57] = hoverCardContent;
    $[58] = t17;
  } else {
    t17 = $[58];
  }
  const t18 = formattedLiquidityUsd ? `$${formattedLiquidityUsd.value}` : "-";
  let t19;
  if ($[59] !== t18) {
    t19 = <span className="text-title-sm">{t18}</span>;
    $[59] = t18;
    $[60] = t19;
  } else {
    t19 = $[60];
  }
  const t20 = formattedLiquidityUsd?.unit;
  let t21;
  if ($[61] !== t20) {
    t21 = <span className="text-title-sm text-muted-foreground">{t20}</span>;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  let t22;
  if ($[63] !== t19 || $[64] !== t21) {
    t22 = <div className="flex items-center">{t19}{t21}</div>;
    $[63] = t19;
    $[64] = t21;
    $[65] = t22;
  } else {
    t22 = $[65];
  }
  let t23;
  if ($[66] !== formattedLiquidity) {
    t23 = <span className="text-xs">{formattedLiquidity}</span>;
    $[66] = formattedLiquidity;
    $[67] = t23;
  } else {
    t23 = $[67];
  }
  let t24;
  if ($[68] !== t17 || $[69] !== t22 || $[70] !== t23) {
    t24 = <div className="gap-sm flex flex-1 flex-col">{t17}{t22}{t23}</div>;
    $[68] = t17;
    $[69] = t22;
    $[70] = t23;
    $[71] = t24;
  } else {
    t24 = $[71];
  }
  return t24;
};
function _temp(isOpen) {
  return trackMetricTooltipOpenChange(isOpen, {
    page: "vault",
    metric: "liquidity",
    vault_version: "v2"
  });
}